// extracted by mini-css-extract-plugin
module.exports = {"row":"TagRow_row__wJinM","title":"TagRow_title__LFoBU","tagGroupUnformatted":"TagRow_tagGroupUnformatted__Kxe9H"};